/* LoginPageRouter.tsx
   Version: 1.1.0
   Date: 2021-03-26
*/

// eslint-disable-next-line
import React from 'react';

import './login.css';
import { AppContext } from '../../AppContext';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Select from '../../basicComponents/Select';

interface LocationFrom {
	from: { pathname: string }
}

export interface LoginPageProps extends RouteComponentProps { 
	checkToken: boolean,
	handleLogin: (result: boolean) => void;
}

export interface LoginPageState {
	packageList: string[] | undefined;
	packageName: string;
	user: string;
	pass: string;
	storeToken: boolean
}

class LoginPageComp extends React.Component<LoginPageProps, LoginPageState> {

	// context
	static contextType = AppContext;
	context!: React.ContextType<typeof AppContext>;

	// constructor
	constructor(props: LoginPageProps) {

		super(props);

		// set state
		this.state = { packageList: undefined, packageName: '', user: '', pass: '', storeToken: false, };

	}

	public render(): JSX.Element {

		// while checking token, return nothing
		if (this.props.checkToken) {
			return ( <div /> );
		}

		// as long as there is no packageList, return nothing
		if (!this.state.packageList) {
			return ( <div /> );
		}

		// return input fields
		return (
			<div className='login'>

				{this.state.packageList.length > 1 ?
					<div className='login-line'>
						<div className="login-select">
							<Select className='login-input-select' name='packageName' value={this.state.packageName} options={this.state.packageList} onChange={this.handleSelectChange}/>
							<i className="login-input-select-arrow fas fa-angle-down"></i>
						</div>
						<label className="login-input-label">package</label>
					</div>
					: 
					null
				}

				<div className='login-line'>
					<input
						className="login-input"
						type="text"
						name='user'
						value={this.state.user}
						onChange={this.handleInputChange}
						required={true}
						autoFocus={true}
					/>
					<label className="login-input-label">user</label>
				</div>

				<div className='login-line'>
					<input
						className="login-input"
						type="password"
						name='pass'
						value={this.state.pass}
						onChange={this.handleInputChange}
						onKeyPress={this.handleKeyPress}
						required={true}
					/>
					<label className="login-input-label">password</label>
				</div>

				<div className='login-line'>
					<input
						className="login-checkbox"
						type="checkbox"
						value="storeToken"
						defaultChecked={false}
						onChange={this.handleChecked}
						onKeyPress={this.handleKeyPress}
					/>
					<label className="login-checkbox-label">remember login</label>
				</div>
				
			</div>
		);

	}

	public componentDidMount(): void {

		// get packageName
		if (!this.state.packageName) {

			this.context.user.getPackages().then( (packageList): void => {
				if (packageList.length > 0) {

					// set packageName to first entry
					let packageName = packageList[0];

					// check if a packageName is stored as cookie
					let pkgName: string | null = null;
					document.cookie.split(';').filter(item => item.includes('packageName=')).forEach(
						item => {
							const pos = item.indexOf('packageName=') + 'packageName='.length;
							pkgName = item.substring(pos);
						});

					// check if packageName is part of packageList
					if (pkgName) {
						if (packageList.includes(pkgName)) {
							packageName = pkgName;
						}
					}
					
					this.setState({ packageList, packageName });
				}
			});

		}

	}

	public componentDidUpdate(): void {

		// check if user is already logged in
		if (this.context.user.isLoggedIn()) {

			// switch to previous page
			console.log('switch to previous page');
			const s: LocationFrom = this.props.location.state as LocationFrom;
			if (s?.from) {
				this.props.history.replace(s.from);
			}
			else {
				this.props.history.replace('/');
			}

		}

	}

	private handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {

		const target = event.target;
        const name = target.dataset.name;
        const value = target.value;

		if (name === 'packageName') {
			this.setState({ packageName: value });
		}

	}

	private handleInputChange = (event: React.ChangeEvent<HTMLInputElement>): void => {

		const name: string = event.target.name;
		switch (name) {
			case 'user': this.setState({ user: event.target.value }); break;
			case 'pass': this.setState({ pass: event.target.value }); break;
		}

	}

	private handleChecked = (): void => {
		this.setState({ storeToken: !this.state.storeToken });
	}

	private handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>): void => {

		if (event.key === "Enter") {

			// set status
			this.context.app.setStatus('check login');

			// call login
			this.context.user.setLogin(this.state.packageName, this.state.user, this.state.pass, this.state.storeToken).then( (result) => {

				if (result === true) {

					this.context.app.setStatus('');

					// switch to previous page
					const s: LocationFrom = this.props.location.state as LocationFrom;
					if (s?.from) {
						this.props.history.replace(s.from);
					}
					else {
						this.props.history.replace('/');
					}

				}
				else {
					this.context.app.setStatus('login failed');
					this.setState({ pass: '' });
				}

				this.props.handleLogin(result);

			});

		}

	}
}

// export LoginPage with Router information
const LoginPage = withRouter(LoginPageComp);
export default LoginPage;
